/**  2026-03-20 B + Adoption section tabs and swiper initialization **/
document.addEventListener('DOMContentLoaded', function () {
    const section = document.querySelector('.adoption');
    if (!section) return;

    // Initialize Swiper
    const swipers = section.querySelectorAll('.adoption-swiper');
    const swiperInstances = [];

    swipers.forEach((swiperEl, index) => {
        const container = swiperEl.closest('.adoption-swiper-container');
        const swiper = new Swiper(swiperEl, {
            slidesPerView: 1.2,
            spaceBetween: 16,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 16,
                }
            },
            navigation: {
                nextEl: container.querySelector('.swiper-button-next-custom'),
                prevEl: container.querySelector('.swiper-button-prev-custom'),
            },
            observer: true,
            observeParents: true,
        });
        swiperInstances.push(swiper);
    });

    // Tab switching logic
    const tabs = section.querySelectorAll('.adoption-tab');
    const tabContents = section.querySelectorAll('.adoption-tab-content');
    const petCountElement = section.querySelector('.adoption-pets-number-count');
    const bottomButtonLink = section.querySelector('.adoption-button-link');

    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            // Remove active class from all tabs and contents
            tabs.forEach(t => t.classList.remove('active'));
            tabContents.forEach(c => c.classList.remove('active'));
            // Add active class to clicked tab
            tab.classList.add('active');

            // Update pet count
            if (petCountElement) {
                const count = tab.getAttribute('data-count') || 0;
                petCountElement.textContent = count;
            }

            // Update bottom button url
            if (bottomButtonLink) {
                const url = tab.getAttribute('data-url') || '#';
                bottomButtonLink.setAttribute('href', url);
            }

            // Show corresponding content
            const tabId = tab.getAttribute('data-tab-id');
            const targetContent = document.getElementById(`tab-content-${tabId}`);
            if (targetContent) {
                targetContent.classList.add('active');
            }
        });
    });
});
/**  2026-03-20 E + Adoption section tabs and swiper initialization **/
